import { apiSlice } from "./apiSlice";

export const awsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getDownloadClientUrl: builder.query({
            query: ({ type }) => `/aws/download-url/${type}`,
        }),
    })

})

export const {
    useGetDownloadClientUrlQuery
} = awsApiSlice